module.exports = __webpack_public_path__ + "img/logo.934c1b91.png";